import React from "react";

const VariableSidebar = ({
    variables = [],
    onInsert,
}) => {
    return (
        <div className="card shadow-sm border-0">
            <div className="card-header bg-white py-2 px-3">
                <h6 className="fw-bold mb-0" style={{ fontSize: "14px" }}>
                    Template Variables
                </h6>
            </div>
            <div
                className="card-body p-2"
                style={{
                    maxHeight: 180,
                    overflowY: "auto",
                }}
            >
                {variables.map((group) => (
                    <div
                        key={group.title}
                        className="mb-2"
                    >
                        <h6 className="text-primary mb-1" style={{ fontSize: "12px" }}>
                            {group.title}
                        </h6>
                        <div className="d-flex flex-wrap gap-1">
                            {group.variables.map(
                                (item) => (
                                    <button
                                        key={item.value}
                                        type="button"
                                        className="btn btn-sm btn-outline-primary py-0 px-2"
                                        style={{ fontSize: "11px" }}
                                        onClick={() =>
                                            onInsert(
                                                item.value
                                            )
                                        }
                                    >
                                        {item.label}
                                    </button>
                                )
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default VariableSidebar;